import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3f0eabc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collecting" }
const _hoisted_2 = { class: "operationCont" }
const _hoisted_3 = { class: "UserManagement-table" }
const _hoisted_4 = { class: "paginationCont" }

import { reactive, ref, onMounted, nextTick, onUnmounted, watch,onActivated } from "vue";
import { getDeptTree, getPage, backCollection } from "../api";
import { Search, RefreshRight, Right } from "@element-plus/icons-vue";
import { FormInstance, ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'AuditPage',
  setup(__props) {

const store = useStore();
const pageSizes = ref([10, 20, 50]);
const hasInitialSearch = ref(false);

const userManuallySetPageSize = ref(false);
const calculateTableRows = () => {
  // 如果用户手动设置了页面大小，则不进行自动计算
  if (userManuallySetPageSize.value) {
    return;
  }
  const tableContainer = document.querySelector(".UserManagement-table");
  if (!tableContainer) {
    console.log("未找到表格容器");
    return;
  }

  const allRows = document.querySelectorAll(".el-table__row");
  if (!allRows.length) {
    if (!hasInitialSearch.value) {
      hasInitialSearch.value = true;
      onSearch(false);
    }
    return;
  }

  // 计算新的 pageSize
  const totalHeight = Array.from(allRows).reduce((sum, row) => {
    return sum + row.getBoundingClientRect().height;
  }, 0);
  const rowHeight = totalHeight / allRows.length;
  const containerHeight = tableContainer.clientHeight;
  const tableHeader = document.querySelector(".el-table__header");
  const headerHeight = tableHeader
    ? tableHeader.getBoundingClientRect().height
    : 0;
  const availableHeight = containerHeight - headerHeight;
  const maxRows = Math.floor(availableHeight / rowHeight);
  const calculatedSize = Math.ceil(maxRows / 5) * 5;

  if (queryForm.pageSize === calculatedSize) {
    return; // 如果分页大小没变，直接返回
  }

  // 更新分页相关配置
  pageSizes.value = [calculatedSize, calculatedSize * 2, calculatedSize * 3];
  defaultPageSize.value = calculatedSize;
  queryForm.pageSize = calculatedSize;
  onSearch(true);
};
const defaultPageSize = ref(10);
let queryForm = reactive({
  condition: {
    deptId: "",
    farmerName: "",
    idCard: "",
    policyNo: "",
    caseNo: "",
    status: "WAITING_CHECK",
  },
  pageIndex: 1,
  pageSize: defaultPageSize.value,
});
const Router = useRouter();
const deptTree = ref<any>([]);
const dialogVisible = ref<Boolean>(false);
const total = ref<number>(0);
const tableData = ref<any>([]);
const queryFormRef = ref<FormInstance>();
onMounted(() => {
  nextTick(() => {
    calculateTableRows();
  });
  getDeptTreeFn();
  let queryPage = sessionStorage.getItem("claimQuery")
    ? JSON.parse(sessionStorage.getItem("claimQuery") || "").audit
    : {};
  console.log("queryForm", queryForm);
  queryForm = reactive({
    ...queryForm,
    ...queryPage,
  });
  // onSearch(true);
  store.commit("SET_AUDITNUM", total.value);
  const debouncedCalculate = debounce(calculateTableRows, 200);
  window.addEventListener("resize", debouncedCalculate);
});
watch(
  tableData,
  () => {
    if (tableData.value.length > 0) {
      // 只在有数据时才重新计算
      nextTick(() => {
        calculateTableRows();
      });
    }
  },
  { immediate: false }
);
onUnmounted(() => {
  window.removeEventListener("resize", calculateTableRows);
  userManuallySetPageSize.value = false;
});
const debounce = (fn: Function, delay: number) => {
  let timer: any = null;
  return function (this: any, ...args: any[]) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      userManuallySetPageSize.value = false;
      fn.apply(this, args);
    }, delay);
  };
};
onActivated(() => {
  console.log("进入了审核中页面");
  
  onSearch(true);
});
const getDeptTreeFn = () => {
  getDeptTree().then((res: any) => {
    deptTree.value = res;
    console.log(res);
  });
};
const onSearch = (type: boolean) => {
  if (type) {
    queryForm.pageIndex = 1;
  }
  sessionStorage.setItem("claimQuery", JSON.stringify({ audit: queryForm }));
  getPage(queryForm).then((res: any) => {
    const { items, totalSize } = res;
    total.value = Number(totalSize);
    tableData.value = items;
  });
  console.log("submit!", queryForm);
};
const resetForm = (formEl: FormInstance | undefined, type: boolean) => {
  if (!formEl) return;
  formEl.resetFields();
  if (type) {
    dialogVisible.value = false;
  }
  sessionStorage.setItem("claimQuery", JSON.stringify({ audit: queryForm }));
};
const viewDetail = (row: any) => {
  sessionStorage.setItem('claimTargetData',JSON.stringify({
      id: row.id,
      name: "AuditPage",
    }))
  Router.push({
    name: "claimTargetData",
    query: {
      id: row.id,
      name: "AuditPage",
    },
  });
};

const formatPolicyType = (row: any) => {
  switch (row.policyType) {
    case "INDIVIDUAL":
      return "个体";
    case "GROUP":
      return "团体";
    default:
      return row.policyType;
  }
};
// 退回采集
const returnCollection = (row: any) => {
  const params = { caseId: row.id, status: "WAITING_CHECK", type: "VALIDATE" };
  backCollection(params)
    .then(() => {
      ElMessage.success("退回采集成功");
      resetForm(queryFormRef.value, false);
      onSearch(true);
    })
    .catch(() => {});
};



const handleSizeChange = (val: number) => {
  userManuallySetPageSize.value = true; // 设置标志位表示用户手动修改了页面大小
  queryForm.pageSize = val;
  onSearch(true);
};
const handleCurrentChange = (val: number) => {
  queryForm.pageIndex = val;
  onSearch(false);
};

return (_ctx: any,_cache: any) => {
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        inline: true,
        model: _unref(queryForm),
        class: "demo-form-inline",
        ref_key: "queryFormRef",
        ref: queryFormRef
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "归属机构",
            prop: "condition.deptId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tree_select, {
                placeholder: "归属机构",
                "check-strictly": "",
                clearable: "",
                modelValue: _unref(queryForm).condition.deptId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(queryForm).condition.deptId) = $event)),
                data: deptTree.value,
                "render-after-expand": false,
                class: "unifiedInputBoxWidth"
              }, null, 8, ["modelValue", "data"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "养殖户姓名",
            prop: "condition.farmerName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(queryForm).condition.farmerName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(queryForm).condition.farmerName) = $event)),
                modelModifiers: { trim: true },
                clearable: "",
                placeholder: "养殖户姓名",
                class: "unifiedInputBoxWidth"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "保单号",
            prop: "condition.policyNo"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(queryForm).condition.policyNo,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(queryForm).condition.policyNo) = $event)),
                modelModifiers: { trim: true },
                clearable: "",
                placeholder: "保单号",
                class: "unifiedInputBoxWidth"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "案件号",
            prop: "condition.caseNo"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(queryForm).condition.caseNo,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(queryForm).condition.caseNo) = $event)),
                modelModifiers: { trim: true },
                clearable: "",
                placeholder: "案件号",
                class: "unifiedInputBoxWidth"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "证件号码",
            prop: "condition.idCard"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(queryForm).condition.idCard,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(queryForm).condition.idCard) = $event)),
                modelModifiers: { trim: true },
                clearable: "",
                placeholder: "证件号码",
                class: "unifiedInputBoxWidth"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                icon: _unref(Search),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (onSearch(true)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查 询")
                ]),
                _: 1
              }, 8, ["icon"]),
              _createVNode(_component_el_button, {
                plain: "",
                icon: _unref(RefreshRight),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (resetForm(queryFormRef.value, false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重 置")
                ]),
                _: 1
              }, 8, ["icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_table, {
        data: tableData.value,
        border: "",
        style: {"width":"100%"},
        height: "100%",
        onRowMounted: calculateTableRows
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "index",
            label: "序号",
            width: "60",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "deptName",
            label: "归属机构",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "farmerName",
            label: "养殖户姓名",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "policyType",
            label: "保单类型",
            align: "center",
            formatter: formatPolicyType
          }),
          _createVNode(_component_el_table_column, {
            prop: "policyNo1",
            label: "政策投保单号",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "policyNo2",
            label: "商业投保单号",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "idCard",
            label: "证件号码",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "caseNo",
            label: "案件号",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "targetNum",
            label: "理赔数量",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "userName",
            label: "查勘人",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "created",
            label: "创建时间",
            width: "180",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "submitTime",
            label: "完成时间",
            width: "180",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "操作",
            width: "180",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                size: "small",
                onClick: _withModifiers(($event: any) => (viewDetail(scope.row)), ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 查看详情 ")
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                size: "small",
                onClick: _withModifiers(($event: any) => (returnCollection(scope.row)), ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 退回采集 ")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_pagination, {
        background: "",
        layout: "total, sizes, prev, pager, next",
        "page-sizes": pageSizes.value,
        total: total.value,
        "current-page": _unref(queryForm).pageIndex,
        "onUpdate:current-page": _cache[7] || (_cache[7] = ($event: any) => ((_unref(queryForm).pageIndex) = $event)),
        "page-size": _unref(queryForm).pageSize,
        "onUpdate:page-size": _cache[8] || (_cache[8] = ($event: any) => ((_unref(queryForm).pageSize) = $event)),
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["page-sizes", "total", "current-page", "page-size"])
    ])
  ]))
}
}

})